module.exports = __webpack_public_path__ + "img/20210701_155459.ac8d3a84.jpg";